import gql from 'graphql-tag';

const DELETE_SYSTEM_ALERT = gql`
  mutation DeleteSystemAlert($id: ID!, $deletedBy: ID!) {
    updateSystemAlert(
      where: { id: $id }
      data: {
        deleted: true
        deletedBy: { connect: { id: $deletedBy } }
        deletedAt: "${new Date().toISOString()}"
      }
    ) {
      id
      deleted
      deletedBy {
        id
        username
        name
      }
      deletedAt
    }
  }
`;

export default DELETE_SYSTEM_ALERT;
